// extracted by mini-css-extract-plugin
export default {"root":"PlasmicDashboardPaidStatusCard_root__0MQpw","text":"PlasmicDashboardPaidStatusCard_text__l0GFt"};